<template>
  <v-text-field
  v-model="localValue"
    :label="label"
    clearable
    outlined
    class="rounded-pill"
    dense
    :error-messages="errorMessages"
    :disabled="disabled"
    @input="clearError"
  />
</template>

<script>
export default {
  name: 'TextFieldFilter',
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    appendIcon() {
      return this.localValue ? '' : 'mdi-magnify';
    },
  },
  methods: {
    clearError() {
      if (this.errorMessages) {
        this.$emit("clear-error");
      }
    },
    onIconClick() {
      if (!this.localValue) {
        this.$emit('search'); 
      }
    },
  },
};
</script>